import { styled, useMediaQuery, useTheme } from '@mui/material';
import CheckboxIcon from './CheckboxIcon';

const Section2Container = styled('section')(({ theme }) => ({
  backgroundColor: '#F4F4F6',
  margin: '0 auto',
  marginBottom: 64,
  display: 'flex',
  width: '100%',
  gap: 120,
  padding: 80,
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    gap: 64,
  },
  [theme.breakpoints.down('md')]: {
    padding: '32px 0 0 0',
  },
  '& div.content': {
    order: 2,
    maxWidth: 526,
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      maxWidth: 672,
      margin: '0 auto',
      order: 1,
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 32px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem',
    },
    '& div.header': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: 32,
      [theme.breakpoints.down('lg')]: {},
      img: {
        height: 100,
        width: 100,
      },
      h2: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '48px',
        color: '#04246B',
      },
      h4: {
        fontSize: 24,
        lineHeight: '36px',
      },
    },
    ul: {
      marginTop: 64,
      marginBottom: 40,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      li: {
        svg: {
          flexShrink: 0,
        },
        textAlign: 'left',
        display: 'flex',
        gap: 16,
        alignItems: 'center',
        fontSize: 20,
        lineHeight: '32px',
        fontWeight: 500,
      },
    },
    p: {
      fontSize: 18,
      lineHeight: '28px',
      textAlign: 'justify',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },
  },
  '& div.image': {
    order: 1,
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      order: 2,
    },
    img: {
      maxWidth: '100%',
      borderRadius: 16,
      height: 736,
      boxShadow: '16px 8px 48px 0px rgba(0, 0, 0, 0.25)',
      [theme.breakpoints.down('lg')]: {
        height: 400,
      },
      [theme.breakpoints.down('md')]: {
        borderRadius: 0,
        height: 'auto',
        boxShadow: 'none',
      },
    },
  },
}));

const Section2 = () => {
  const theme = useTheme();
  const mdScreen = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Section2Container>
      <div className="content">
        <div className="header">
          <img
            className="shadow-left"
            src="https://bucket.ywhdev.com/wl/?id=5V7mDFnKDRu6wJOcnWp2sQUyC7YnhUEk&fmode=open"
            alt=""
          />
          <h2>The importance of proper pricing</h2>
        </div>
        <ul>
          <li>
            <CheckboxIcon />
            Faster sale and less inconvenience
          </li>
          <li>
            <CheckboxIcon />
            Exposure to more buyers
          </li>
          <li>
            <CheckboxIcon />
            Increases Realtors response
          </li>
          <li>
            <CheckboxIcon />
            Generates more advertising/sign calls
          </li>
          <li>
            <CheckboxIcon />
            Attracts higher offers
          </li>
          <li>
            <CheckboxIcon />
            Means more money to seller
          </li>
          <li>
            <CheckboxIcon />
            Avoids being "shopworn"
          </li>
        </ul>
        <p>
          What really matters is how your home stacks up against the others currently offered for sale and recently sold
          in your neighborhood. Buyers will be comparing.
        </p>
      </div>
      <div className="image">
        <img
          className="shadow-left"
          src={
            mdScreen
              ? 'https://bucket.ywhdev.com/wl/?id=Rlg8oqASO3lwUqOybldBHDECSEvJsge7&fmode=open'
              : 'https://bucket.ywhdev.com/wl/?id=Fz6URfutHJialRMJwpTIP3NJLTsPOCtW&fmode=open'
          }
          alt=""
        />
      </div>
    </Section2Container>
  );
};

export default Section2;
